import { isPlatformBrowser } from '@angular/common';
import { inject, PLATFORM_ID } from '@angular/core';

import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  #storage: Storage;
  #platformId: object;
  constructor() {
    // eslint-disable-next-line no-restricted-syntax -- test
    this.#platformId = inject(PLATFORM_ID);
    // eslint-disable-next-line no-restricted-syntax -- low level file, it's ok
    this.#storage = isPlatformBrowser(this.#platformId)
      ? localStorage
      : ({
          getItem: () => null, // Return null on the server
          setItem: () => {}, // Do nothing on the server
          removeItem: () => {}, // Do nothing on the server
          clear: () => {} // Do nothing on the server
        } as unknown as Storage);
  }

  setItem(key: string, value: any): void {
    this.#storage.setItem(key, value);
  }
  getItem(key: string): string | null {
    return this.#storage.getItem(key);
  }
  removeItem(key: string): void {
    this.#storage.removeItem(key);
  }
  clear() {
    this.#storage.clear();
  }
}
